import React from "react";
import PhaseReadingChart from "./PhaseReadingChart";
import { images } from "../../common/images";

const CURRENT_DECIMALS = { axis: 0, tooltip: 2 };

export default function CurrentLineChart({ selectedDeviceSelectedDayData }) {
  return (
    <PhaseReadingChart
      selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
      reading="c"
      name="Current"
      image={images.chartCurrent}
      iconBackgroundColor="rgba(16, 163, 127, 0.10)"
      unit="A"
      axisTitle="Amps (A)"
      fromZero
      decimals={CURRENT_DECIMALS}
    />
  );
}
